// extracted by mini-css-extract-plugin
module.exports = {"titleCardSection":"styles_titleCardSection__B8Mbh"};